import styled from "styled-components";

export const SectionHeader = styled.h6`
    margin: 8px 0;
`;
